import "./DateTimeTools.css"
import ToolHeader from "../../Components/ToolHeader";
import { Row, Col } from "react-bootstrap";
import { useState, useEffect, useCallback } from "react";

import { TimeDifference } from "../../Services/APIService";
import { ReactComponent as CalenderIcon } from "../../Icons/calendar-dots.svg";

const defaultDurationPayload = {
    fromDateTime: "2026-01-05T10:00",
    toDateTime: "2027-01-06T15:30",
    timezone: "UTC",
};


function TimeDifferenceCalculator() {
    const toolFav = { toolName: 'Time Difference Calculator', Iconpath: "/FileCodeRaw.svg" };

    
    

    const [payload, setPayload] = useState(defaultDurationPayload);

    const [result, setResult] = useState({
        milliseconds: 0,
        seconds: 0,
        minutes: 0,
        hours: 0,
        days: 0,
        timezone: "UTC",
        processingTimeMs: 0,
    });

    const [loading, setLoading] = useState(false);

    // FORMAT DATE
    const formatDate = (dateString) => {
    if (!dateString) return "";

    return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: payload.timezone || "UTC",
    }).format(new Date(dateString));
};
    // API CALL
    const calculateDuration = useCallback(async (updatedPayload) => {
        try {
            setLoading(true);

            const res = await TimeDifference(updatedPayload);

            if (res?.data) {
                setResult(res.data);
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, []);
    const handleDateChange = async (field, value) => {
        const updatedPayload = {
            ...payload,
            [field]: value,
        };

        setPayload(updatedPayload);

        await calculateDuration(updatedPayload);
    };

    useEffect(() => {
        calculateDuration(defaultDurationPayload);
    }, [calculateDuration]);

    const getCurrentDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const handleNowClick = (field) => {
        const currentDateTime = getCurrentDateTime();
        handleDateChange(field, currentDateTime);
    };

    const totalYears = Math.floor(result.days / 365);
    const remainingDays = result.days % 365;
    const totalMonths = Math.floor(remainingDays / 30);
    const totalWeeks = Math.floor(remainingDays / 7);

    return (
        <>
            <Col>
                <ToolHeader title="Time Difference Calculator" description="Calculate the duration between two dates and times" toolFav={toolFav} />



                <Row className='Formatter' style={{justifyContent:"flex-start"}}>
                    <Col>
                        <div className="duration-page">
                            <div className="duration-container">

                                {/* TOP ROW */}
                                <div className="top-grid">

                                    {/* FROM */}
                                    {/* FROM */}
                                    <div className="input-card">

                                        <div className="card-top">
                                            <span className="label">FROM</span>
                                        <span className="now-text" onClick={() => handleNowClick("fromDateTime")}>Now</span>
                                    </div>

                                    <div className="date-box-wrapper">

                                            <input
                                                type="datetime-local"
                                                className="hidden-date-input"
                                                value={payload.fromDateTime}
                                                onChange={(e) =>
                                                    handleDateChange("fromDateTime", e.target.value)
                                                }
                                            />

                                            <div className="date-box">
                                                <span>
                                                    {formatDate(payload.fromDateTime)}
                                                </span>

                                                <CalenderIcon className="headerIcon" />
                                            </div>

                                        </div>

                                    </div>

                                    {/* TO */}
                                    {/* TO */}
                                    <div className="input-card">

                                        <div className="card-top">
                                            <span className="label">TO</span>
                                        <span className="now-text" onClick={() => handleNowClick("toDateTime")}>Now</span>
                                    </div>

                                    <div className="date-box-wrapper">

                                            <input
                                                type="datetime-local"
                                                className="hidden-date-input"
                                                value={payload.toDateTime}
                                                onChange={(e) =>
                                                    handleDateChange("toDateTime", e.target.value)
                                                }
                                            />

                                            <div className="date-box">
                                                <span>
                                                    {formatDate(payload.toDateTime)}
                                                </span>

                                                <CalenderIcon className="headerIcon" />
                                            </div>

                                        </div>

                                    </div>

                                </div>

                                {/* TOTAL DURATION */}
                                <div className="duration-card">

                                    <p className="label">TOTAL DURATION</p>

                                    <h1 className="duration-text">
                                        {result.days} days, {result.hours % 24} hours,{" "}
                                        {result.minutes % 60} minutes
                                    </h1>

                                    <p className="duration-sub">
                                        {formatDate(payload.fromDateTime)} →{" "}
                                        {formatDate(payload.toDateTime)}
                                    </p>

                                </div>

                                {/* STATS */}
                                <div className="diff-stats-grid">
                                    <div className="diff-stat-card">
                                        <span className="stat-label">{totalYears}</span>
                                        <p>YEARS</p>
                                    </div>
                                    <div className="diff-stat-card">
                                        <span className="stat-label">{totalMonths}</span>
                                        <p>MONTHS</p>
                                    </div>

                                    <div className="diff-stat-card">
                                        <span className="stat-label">{totalWeeks}</span>
                                        <p>WEEKS</p>
                                    </div>

                                    <div className="diff-stat-card active">
                                        <span className="stat-label">{result.days}</span>
                                        <p>DAYS</p>
                                    </div>

                                    <div className="diff-stat-card">
                                        <span className="stat-label">{result.hours}</span>
                                        <p>HOURS</p>
                                    </div>

                                    <div className="diff-stat-card">
                                        <span className="stat-label">{result.minutes}</span>
                                        <p>MINUTES</p>
                                    </div>

                                </div>

                                {/* TOTAL CONVERSIONS */}
                                <div className="conversion-card">

                                    <p className="label">TOTAL CONVERSIONS</p>

                                    <div className="conversion-grid">

                                        <div className="conversion-item">
                                            <span>Total seconds</span>
                                            <strong>{result.seconds.toLocaleString()}</strong>
                                        </div>

                                        <div className="conversion-item">
                                            <span>Total days</span>
                                            <strong>{result.days}</strong>
                                        </div>

                                        <div className="conversion-item">
                                            <span>Total minutes</span>
                                            <strong>{result.minutes.toLocaleString()}</strong>
                                        </div>

                                        <div className="conversion-item">
                                            <span>Total weeks</span>
                                            <strong>{Math.round(result.days / 7).toLocaleString()}</strong>
                                        </div>

                                        <div className="conversion-item">
                                            <span>Total hours</span>
                                            <strong>{result.hours.toLocaleString()}</strong>
                                        </div>

                                        <div className="conversion-item">
                                            <span>Total months (a)</span>
                                            <strong>{Math.round(result.days / 30).toLocaleString()}</strong>
                                        </div>

                                    </div>

                                    {loading && (
                                        <p className="loading-text">
                                            Calculating...
                                        </p>
                                    )}

                                </div>

                            </div>
                        </div>
                    </Col>
                </Row>
            </Col >
        </>
    )
}

export default TimeDifferenceCalculator;
